import {
  Directive,
  ElementRef,
  HostListener,
  input,
  inject,
} from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'img[fallback]',
  standalone: true,
})
export class ImageFallbackDirective {
  private elementRef = inject(ElementRef);

  readonly fallback = input.required<string>();

  @HostListener('error')
  loadFallbackOnError() {
    const element: HTMLImageElement = <HTMLImageElement>(
      this.elementRef.nativeElement
    );
    element.src = this.fallback();
  }
}
